import React, { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { VscSaveAs } from "react-icons/vsc";
import { addAssetInGrnApi } from "../../../services/GrnService";
import { Col, Row } from "react-bootstrap";
import AssetCardList from "../GrnAdd/AssetCardList";
import AssetStepperForm from "../GrnAdd/AssestStepperForm";
import { toast } from "react-toastify";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import AssetAddPreview from "./AssetAddPreview";
const assetKeyMap = {
  assetName: "name",
  catagory: "category",
  sub_catagory: "sub_category",
  other_info: "unit_other_details",
  purchaseCost: "purchase_cost",
  purchaseDate: "purchase_date",
  assetId: "manual_asset_id",
  image: "asset_unit_image",
  warrantyEnd: "warranty_end_date",
  insuranceProvider: "insurance_provider",
  policyNumber: "policy_number",
  insuranceExpiry: "insurance_expiry",
  lifespan: "expected_lifespan_months",
  scrapValue: "scrap_value",
  depreciation_method: "depreciation_method",
  depreciationRate: "depreciation_rate",
  serviceCycle: "service_cycle_months",
  manufacturer: "manufacturer",
  brand: "brand",
  modelNumber: "model_number",
  serialNumber: "serial_number",
  warrantyFile: "warranty_file",
  insuranceFile: "insurance_file",
};
const AssetAdd = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [showPreview, setShowPreview] = useState(false);
  const [assets, setAssets] = useState([]);
  const [formMode, setFormMode] = useState(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [copyIndex, setCopyIndex] = useState(null);
  const [actualEditingIndex, setActualEditingIndex] = useState(null);

  const [assetAddLoading, setAssetAddLoading] = useState(false);
  const initialAssetValues = useMemo(() => {
    if (formMode === "edit" && editingIndex !== null) {
      return assets[editingIndex] || {};
    }

    if (formMode === "copy" && copyIndex !== null) {
      const original = assets[copyIndex] || {};
      const copied = {};

      const copyExcludeFields = [
        "insuranceFile",
        "image",
        "warrantyFile",
        "serialNumber",
        "modelNumber",
      ];

      for (const key in original) {
        if (!copyExcludeFields.includes(key)) {
          copied[key] = original[key];
        }
      }

      return copied;
    }

    return {};
  }, [formMode, editingIndex, copyIndex, assets]);

  const handleEditIcon = (index) => {
    setFormMode("edit");
    setEditingIndex(index);
    setActualEditingIndex(index);
    setCopyIndex(null);
  };

  const handleCopyIcon = (index) => {
    setFormMode("copy");
    setCopyIndex(index);
    setEditingIndex(null);
    toast.success("Coppied successfully");
  };

  const handleResetFormMode = () => {
    setFormMode(null);
    setEditingIndex(null);
    setCopyIndex(null);
    setActualEditingIndex(null);
  };

  const handleResetGrn = () => {
    setAssets([]);
    setEditingIndex(null);
  };

  const handleSaveAsset = (assetData) => {
    if (actualEditingIndex !== null) {
      const updated = [...assets];
      updated[actualEditingIndex] = assetData;
      setAssets(updated);
    } else {
      setAssets([...assets, assetData]);
    }

    handleResetFormMode();
  };

  const handleDeleteAsset = (assetindex) => {
    const updated = assets.filter((a, i) => i != assetindex);
    setAssets(updated);
    setEditingIndex(null);
    setActualEditingIndex(null);
    setFormMode("");
  };

  const handleSubmit = () => {
    const formData = new FormData();

    const asset_unit_list = [];
    assets.forEach((asset, index) => {
      const asset_unit_obj = {};
      for (const key in asset) {
        let value;
        const mappedKey = assetKeyMap[key];
        if (key === "catagory") {
          value = asset[key]?.value || "";
        } else if (key === "sub_catagory") {
          value = asset[key]?.value || "";
        } else {
          value = asset[key];
        }
        if (!mappedKey) continue;

        if (value instanceof File) {
          formData.append(`${mappedKey}_${index}`, value);
        } else if (value !== null && value !== undefined) {
          asset_unit_obj[mappedKey] = value;
        }
      }
      asset_unit_list.push(asset_unit_obj);
    });
    formData.append("asset_unit_list", JSON.stringify(asset_unit_list));

    setAssetAddLoading(true);
    addAssetInGrnApi(id, formData)
      .then((res) => {
        toast.success("Asset added successfully");
        handleResetGrn();
        navigate(`/grn/${id}`);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setAssetAddLoading(false);
      });
  };

  return (
    <div className="container-fluid">
      <div className="mb-3">
        <h2 className="text-primary">GRN Edit</h2>
        <nav>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/grn">GRN List</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/grn/${id}`}>GRN Details</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add Asset
            </li>
          </ol>
        </nav>
      </div>

      <Row>
        <Col md={8}>
          <AssetStepperForm
            isEditMode={actualEditingIndex !== null}
            onSubmit={handleSaveAsset}
            onCancel={handleResetFormMode}
            initialValues={initialAssetValues}
          />
        </Col>
        <Col md={4}>
          <AssetCardList
            assets={assets}
            onEdit={handleEditIcon}
            onCopy={handleCopyIcon}
            onDelete={handleDeleteAsset}
            setShowPreview={setShowPreview}
          />
        </Col>
      </Row>
      <div className="d-flex justify-content-end mt-4">
        <button
          className="btn btn-primary"
          disabled={assets?.length === 0 || assetAddLoading}
          onClick={handleSubmit}
        >
          {assetAddLoading && <Spinner animation="border" size="sm" />}
          <VscSaveAs className="me-1" size={18} />Add Asset
        </button>
      </div>
      <AssetAddPreview
        show={showPreview}
        onClose={() => setShowPreview(false)}
        asset={assets}
      />
    </div>
  );
};

export default AssetAdd;
